import { type ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';
import { LandingContent } from './LandingContent';

export const LandingPage = (): ReactElement => {
  const { session } = useAuth();

  if (session) {
    return <Navigate to="/execution-runs" replace />;
  }

  return <LandingContent />;
};
